import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('asset_licence')
export class AssetLicense{
    @PrimaryGeneratedColumn('increment',{
        name:'license_id'
    })
    licenseId:number;

    @Column({
        nullable: false,
        name: "license_name",
    })
    licenseName: number;

    @Column({
        name: "reference_number",
    })
    referenceNumber: number;

    @Column({
        name: "company",
    })
    company: string;

    @Column({
        nullable: false,
        name: "license_number",
    })
    licenseNumber: string;

    @Column({
        name: "responsibility",
    })
    responsibility: string;

    @Column({
        nullable: false,
        name: "expiry_date",
    })
    expiryDate: Date;

    @Column('boolean', {
        name:'is_active',
        default: true,
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column({
        nullable: true,
        name: "renewal_person_name",
    })
    renewalPersonName?: string;

    @Column({
        nullable: true,
        name: "renewal_start_date",
    })
    renewalStartDate?: Date;

    @Column({
        nullable: true,
        name: "renewal_expiry_date",
    })
    renewalExpiryDate?: Date;

    @Column({
        nullable: true,
        name: "plant",
    })
    plantId?: number;
}
